<div class="modal-overlay" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="status-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Flag Customer Active?</h2>
        <button class="close-button" (click)="onClose()">
          <svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path  d="M15 5L5 15M5 5L15 15" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <p class="modal-description">
        Are you sure you want to mark this customer active? This action is reversible. Once a customer is active:
      </p>
      
      <div class="points-list">
        <div class="point-item">
          <div class="point-content">
            <div class="icon-container">
              <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="3" width="16" height="16" rx="8" fill="#1DA750"/>
                <path d="M4.5 11L7 13.5L12 8.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </div>
            <span class="point-text">They can be assigned new jobs again.</span>
          </div>
        </div>
        
        <div class="point-item">
          <div class="point-content">
            <div class="icon-container">
              <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="3" width="16" height="16" rx="8" fill="#1DA750"/>
                <path d="M4.5 11L7 13.5L12 8.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </div>
            <span class="point-text">They will appear in customer selection.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-buttons">
        <button class="btn btn-secondary btn-medium" (click)="onClose()" [disabled]="isLoading">
          Cancel
        </button>
        <button class="btn btn-primary btn-medium" (click)="onConfirm()" [disabled]="isLoading">
          <span *ngIf="isLoading" class="loading-spinner"></span>
          Yes, Mark Active
        </button>
      </div>
    </div>
  </div>
</div>
